
 <app-filter [countryList]="countryList" [selectedCountryIsoCode]="selectedCountryIsoCode" (filters)="onFiltersChanged($event)" (cartClick)="onCartClick()"></app-filter>
 
<button (click)="scrollToTop()" *ngIf="showScrollToTopButton" class="scroll-to-top">
  <i class="fa fa-arrow-up"></i>
</button> 

<div class="row">
  <ng-container *ngIf="displayedProducts.length > 0; else noProducts">
    <app-product-card class="card col-sm-3 mb-3 mt-3" *ngFor="let product of displayedProducts" [product]="product"  ></app-product-card>
  </ng-container>
  <ng-template #noProducts>
    <div class="col-12 text-center">
      <p>No products found.</p>
    </div>
  </ng-template>
  <div #scrollAnchor></div>
</div>
